import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useSelector } from 'react-redux';
import { SectionV2Preview } from '@module/form-components';
import { useMemo } from 'react';
import { Skeleton } from 'antd';
import { Headings, QuestionReleases, Questions } from '@module/form';
import Image from 'next/image';
import { QuestionsPreviewContainer } from '../questions';
import styled from 'styled-components';
import { getSize, PrimaryButton, SecondaryButton } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledButtonGroup = styled.div.withConfig({
  displayName: "section-previewcontainer__StyledButtonGroup",
  componentId: "sc-3s4f2m-0"
})(["display:flex;justify-content:space-between;padding:", " 0 150px;flex-grow:2;"], getSize('padding24'));

var orderQuestionsBySectionSummaries = function orderQuestionsBySectionSummaries(questions, sections) {
  var ordered = [];
  var usedIds = new Set(); // Match section summary UI order (array order = Section 1, 2, 3...)

  sections.forEach(function (section) {
    questions.filter(function (q) {
      var _q$sectionId;

      return ((_q$sectionId = q.sectionId) === null || _q$sectionId === void 0 ? void 0 : _q$sectionId.toString()) === section.id.toString();
    }).forEach(function (q) {
      ordered.push(q);
      usedIds.add(q.id.toString());
    });
  });
  questions.forEach(function (q) {
    if (!usedIds.has(q.id.toString())) {
      ordered.push(q);
    }
  });
  return ordered;
};

export var SectionPreviewContainer = function SectionPreviewContainer(_ref) {
  var _page$questions, _page$selectedSection, _page$sectionSummarie;

  var section = _ref.section,
      onPin = _ref.onPin,
      pinnedSectionId = _ref.pinnedSectionId,
      onCancelPin = _ref.onCancelPin,
      onPinQuestion = _ref.onPinQuestion,
      pinnedQuestionId = _ref.pinnedQuestionId,
      formPreviewLabels = _ref.formPreviewLabels,
      onNextSection = _ref.onNextSection,
      onPreviousSection = _ref.onPreviousSection,
      navigationLabels = _ref.navigationLabels,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal-form' : _ref$type;
  // Selectors
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var questions = (_page$questions = page === null || page === void 0 ? void 0 : page.questions) !== null && _page$questions !== void 0 ? _page$questions : [];
  var form = page === null || page === void 0 ? void 0 : page.form;
  var selectedSectionIndex = (_page$selectedSection = page === null || page === void 0 ? void 0 : page.selectedSectionIndex) !== null && _page$selectedSection !== void 0 ? _page$selectedSection : 0;
  var sectionSummaries = (_page$sectionSummarie = page === null || page === void 0 ? void 0 : page.sectionSummaries) !== null && _page$sectionSummarie !== void 0 ? _page$sectionSummarie : [];

  var renderSection = function renderSection() {
    if (!section) {
      return /*#__PURE__*/_jsx(Skeleton, {
        paragraph: {
          rows: 3
        }
      });
    }

    return /*#__PURE__*/_jsx(SectionV2Preview, {
      section: section,
      PinIcon: /*#__PURE__*/_jsx(Image, {
        src: "/icons/pin.svg",
        alt: "pin",
        width: 20,
        height: 20
      }),
      onPinSection: onPin,
      pinnedSectionId: pinnedSectionId,
      onCancelPin: onCancelPin,
      audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer,
      readonly: true
    });
  };

  var filterQuestions = useMemo(function () {
    if (!form) {
      return [];
    }

    var sections = sectionSummaries !== null && sectionSummaries !== void 0 && sectionSummaries.length ? sectionSummaries : form.sections || [];

    if (type === 'form-release') {
      return QuestionReleases.sortQuestionsWithIndexBySectionsOrder(questions, sections).filter(function (q) {
        return q.sectionId === section.id.toString();
      });
    }

    var orderedQuestions = orderQuestionsBySectionSummaries(questions, sections);
    return Questions.sortQuestionsWithIndexAndSection(orderedQuestions).filter(function (q) {
      return q.sectionId === section.id.toString();
    });
  }, [form, questions, section, sectionSummaries, type]);

  var renderQuestions = function renderQuestions() {
    if (!form) {
      return /*#__PURE__*/_jsx(Skeleton, {
        paragraph: {
          rows: 10
        }
      });
    }

    var filterHeadings = Headings.sort(form.headings.filter(function (h) {
      return h.sectionId === section.id.toString();
    }));
    var filterQuestionsWithHeadings = Headings.sortWithQuestions(filterHeadings, filterQuestions);
    return /*#__PURE__*/_jsx(QuestionsPreviewContainer, {
      questionsWithHeadings: filterQuestionsWithHeadings,
      onPin: onPinQuestion,
      pinnedQuestionId: pinnedQuestionId,
      onCancelPin: onCancelPin,
      labels: _objectSpread(_objectSpread({}, formPreviewLabels.question), formPreviewLabels.matchingQuestion),
      audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderSection(), /*#__PURE__*/_jsx("br", {}), renderQuestions(), navigationLabels && /*#__PURE__*/_jsxs(StyledButtonGroup, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        disabled: !sectionSummaries || selectedSectionIndex - 1 < 0 ? true : false,
        onClick: onPreviousSection,
        children: navigationLabels.previousSection
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        disabled: !sectionSummaries || selectedSectionIndex + 1 >= (sectionSummaries === null || sectionSummaries === void 0 ? void 0 : sectionSummaries.length) ? true : false,
        onClick: onNextSection,
        children: navigationLabels.nextSection
      })]
    })]
  });
};